import { FormProvider, useForm } from "react-hook-form";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import {
    AtualizarUsuarioController,
    ListarUsuariosController,
} from "../../../../../Controllers/Geral/GestaoUsuarios/UsuariosController";
import { AtualizarUsuarioInterface } from "../../../../../Interfaces/Geral/GestaoUsuarios/UsuariosInterface";
import { replaceClass } from "../../../../../Tools/Classtools";
import { Switch } from "../../../../../Components/CardsPages/Forms/Switch";
import UnForm from "../../../../../Components/Form";
import { useState } from "react";
import { useUserInfor } from "../../../../../Context/User";
import {
    ListarModulosController,
    ListarUraTelefoneController,
} from "../../../../../Controllers/Geral/Documentos/DocumentosController";
import {
    AtualizarAsssinaturaUsuarioController,
    CadastrarFotoUsuarioController,
} from "../../../../../Controllers/Users/UsersController";
import OrSpinner from "../../../../../Components/Utils/OrSpinner";
import userDefault from "../../../../../Assets/img/user.png";
import assinaturaDefault from "../../../../../Assets/img/assinatura.png";
import { ListarPerfilUsuarioVendasController } from "../../../../../Controllers/Vendas/Usuario/UsuarioController";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";

interface EditDataFormInterface {
    name: string;
    rg: string;
    cpf: string;
    LoginUAU: string;
    SenhaUAU: string;
    NRad: number;
    IDr: number;
    Arquivo: File;
    ArquivoFotoUsuario: File;
    ID_USUARIO_COPIA: number;
    ID_PERFIL_USUARIO: number;
    ID_MODULO_PRINCIPAL: number;
    COD_DDI: string;
    COD_DDD: string;
    NR_TELEFONE_WPP: string;
}
interface DadosPropsInterface {
    user: AtualizarUsuarioInterface;
    updateUser: (idGrupo: number) => void;
    updateList: () => void;
    loading: boolean;
    setShow: (value: React.SetStateAction<boolean>) => void;
}

export default function Dados(props: DadosPropsInterface) {
    const { user, updateList, updateUser, loading } = props;
    const formHook = useForm<EditDataFormInterface>();
    const { getValues } = formHook;

    const { OrgInfor } = useUserInfor();

    const [showSubmit, setShowSubmit] = useState(false);
    const [idUsuarioCopia, setIdUsuarioCopia] = useState<number>();
    const [idPerfilUsuario, setIdPerfilUsuario] = useState<number>();
    const [file, setFile] = useState<File>();
    const [fileFotoUsuario, setFileFotoUsuario] = useState<File>();
    const [ativo, setAtivo] = useState(user.FL_ATIVO || false);
    const [admnistrador, setAdmnistrador] = useState(
        user.FL_ADMINISTRADOR || false
    );

    const [nrTelefone, setNrTelefone] = useState<string>(
        user.NR_TELEFONE_WPP || ""
    );

    const { value: lstPerfilUsuario, loading: lstPerfilUsuarioLoading } =
        useAsyncEffect(() => ListarPerfilUsuarioVendasController(), []);

    function handleEditDataFormSubmit(formData: EditDataFormInterface) {
        const {
            name,
            rg,
            cpf,
            LoginUAU,
            SenhaUAU,
            NRad,
            IDr,
            Arquivo,
            ArquivoFotoUsuario,
            ID_USUARIO_COPIA,
            ID_PERFIL_USUARIO,
            ID_MODULO_PRINCIPAL,
            COD_DDI,
            COD_DDD,
            NR_TELEFONE_WPP,
        } = formData;

        if (
            name !== user.DS_NOME ||
            rg !== user.NR_RG ||
            cpf !== user.DS_CPF ||
            LoginUAU !== user.DS_LOGIN_UAU ||
            SenhaUAU !== user.DS_SENHA_UAU ||
            NRad !== user.NR_AGENTE_DISCADOR ||
            IDr !== user.ID_RAMAL_DISCADOR ||
            Arquivo !== user.ARQUIVO ||
            ArquivoFotoUsuario !== user.ArquivoFotoUsuario ||
            ID_USUARIO_COPIA !== user.ID_USUARIO_COPIA ||
            ID_PERFIL_USUARIO !== user.ID_PERFIL_USUARIO ||
            ID_MODULO_PRINCIPAL !== user.ID_MODULO_PRINCIPAL ||
            COD_DDI !== user.COD_DDI ||
            COD_DDD !== user.COD_DDD ||
            NR_TELEFONE_WPP !== user.NR_TELEFONE_WPP
        ) {
            AtualizarUsuarioController(
                {
                    ...user,
                    DS_NOME: name,
                    NR_RG: rg,
                    DS_CPF: cpf,
                    DS_LOGIN_UAU: LoginUAU,
                    DS_SENHA_UAU: SenhaUAU,
                    NR_AGENTE_DISCADOR: NRad,
                    ID_RAMAL_DISCADOR: IDr,
                    ID_PERFIL_USUARIO: idPerfilUsuario ?? 0,
                    ID_MODULO_PRINCIPAL: ID_MODULO_PRINCIPAL ?? 0,
                    COD_DDI: COD_DDI,
                    COD_DDD: COD_DDD,
                    NR_TELEFONE_WPP: NR_TELEFONE_WPP,
                },
                idUsuarioCopia ?? 0
            ).then(() => {
                if (file) {
                    const formData = new FormData();
                    formData.append("arquivo", file);

                    AtualizarAsssinaturaUsuarioController(
                        formData,
                        user.ID_USUARIO
                    ).finally(() => {
                        updateList();
                        updateUser(user.ID_USUARIO);
                        props.setShow(false);
                    });
                }
                if (fileFotoUsuario) {
                    const formDataFotoUsuario = new FormData();
                    formDataFotoUsuario.append("arquivo", fileFotoUsuario);

                    CadastrarFotoUsuarioController(
                        formDataFotoUsuario,
                        user.ID_USUARIO
                    ).finally(() => {
                        updateList();
                        updateUser(user.ID_USUARIO);
                        props.setShow(false);
                    });
                }
            });
        }

        replaceClass("dados_form_submit_button", "d-flex", "d-none");
    }
    const handleInputChange = () => {
        const {
            name,
            rg,
            cpf,
            LoginUAU,
            SenhaUAU,
            NRad,
            IDr,
            Arquivo,
            ArquivoFotoUsuario,
            ID_USUARIO_COPIA,
            ID_PERFIL_USUARIO,
            ID_MODULO_PRINCIPAL,
            COD_DDI,
            COD_DDD,
            NR_TELEFONE_WPP,
        } = getValues([
            "cpf",
            "rg",
            "name",
            "LoginUAU",
            "SenhaUAU",
            "NRad",
            "IDr",
            "Arquivo",
            "ArquivoFotoUsuario",
            "ID_USUARIO_COPIA",
            "ID_PERFIL_USUARIO",
            "ID_MODULO_PRINCIPAL",
            "COD_DDI",
            "COD_DDD",
            "NR_TELEFONE_WPP",
        ]);
        const showSubmit =
            name !== user.DS_NOME ||
            rg !== user.NR_RG ||
            cpf !== user.DS_CPF ||
            LoginUAU !== user.DS_LOGIN_UAU ||
            SenhaUAU !== user.DS_SENHA_UAU ||
            NRad !== user.NR_AGENTE_DISCADOR ||
            IDr !== user.ID_RAMAL_DISCADOR ||
            Arquivo !== user.ARQUIVO ||
            ArquivoFotoUsuario !== user.ArquivoFotoUsuario ||
            ID_USUARIO_COPIA !== user.ID_USUARIO_COPIA ||
            ID_PERFIL_USUARIO !== user.ID_PERFIL_USUARIO ||
            ID_MODULO_PRINCIPAL !== user.ID_MODULO_PRINCIPAL ||
            COD_DDI !== user.COD_DDI ||
            COD_DDD !== user.COD_DDD ||
            NR_TELEFONE_WPP !== user.NR_TELEFONE_WPP;
        setShowSubmit(showSubmit);
    };

    return (
        <OrSpinner loading={loading || lstPerfilUsuarioLoading} spinner="capys">
            <div className="row">
                <div className="col-12">
                    <div className="d-flex align-items-center justify-content-around">
                        <div>
                            <Switch
                                label="Usuário Ativo"
                                labelClassName="text-center font-weight-bold"
                                color="success"
                                swicthSize="lg"
                                name="FL_ATIVO"
                                checked={ativo}
                                type="checkbox"
                                onChange={() => {
                                    setAtivo(!user.FL_ATIVO);
                                    AtualizarUsuarioController(
                                        {
                                            ...user,
                                            FL_ATIVO: !user.FL_ATIVO,
                                        },
                                        user.ID_USUARIO
                                    ).then(() => {
                                        updateList();
                                        updateUser(user.ID_USUARIO);
                                    });
                                }}
                            />
                        </div>
                        <div>
                            <Switch
                                label="Administrador"
                                labelClassName="text-center font-weight-bold"
                                color="info"
                                swicthSize="lg"
                                name="FL_ADMINISTRADOR"
                                checked={admnistrador}
                                type="checkbox"
                                onChange={() => {
                                    setAdmnistrador(!user.FL_ADMINISTRADOR);
                                    AtualizarUsuarioController(
                                        {
                                            ...user,
                                            FL_ADMINISTRADOR:
                                                !user.FL_ADMINISTRADOR,
                                        },
                                        user.ID_USUARIO
                                    ).then(() => {
                                        updateList();
                                        updateUser(user.ID_USUARIO);
                                    });
                                }}
                            />
                        </div>
                        <div className="mb-3 d-flex justify-content-center align-items-center text-center">
                            <div className="d-flex flex-column justify-content-center align-items-center">
                                <img
                                    className="border border-secondary rounded"
                                    src={
                                        user.IM_FOTO
                                            ? user.IM_FOTO
                                            : userDefault
                                    }
                                    alt="Foto do usuário"
                                    style={{
                                        height: "150px",
                                        width: "150px",
                                    }}
                                />
                                <label className="mt-1 font-weight-bold">
                                    {user.IM_FOTO
                                        ? "Foto do usuário"
                                        : "Sem foto do usuário"}
                                </label>
                            </div>
                        </div>
                        <div className="mb-3 d-flex justify-content-center align-items-center text-center">
                            <div className="d-flex flex-column justify-content-center align-items-center">
                                <img
                                    className="border border-secondary rounded"
                                    src={
                                        user.DS_EMAIL_ASSINATURA
                                            ? user.DS_EMAIL_ASSINATURA
                                            : assinaturaDefault
                                    }
                                    alt="Assinatura de email do usuário"
                                    style={{
                                        height: "150px",
                                        width: "150px",
                                    }}
                                />
                                <label className="mt-1 font-weight-bold">
                                    {user.DS_EMAIL_ASSINATURA
                                        ? "Assinatura do usuário"
                                        : "Sem assinatura do usuário"}
                                </label>
                            </div>
                        </div>
                    </div>

                    <hr />

                    <FormProvider {...formHook}>
                        <UnForm
                            usingContext
                            handleSubmit={handleEditDataFormSubmit}
                            className="row"
                        >
                            <div className="form-group col-12 col-lg-4">
                                <UnForm.Input
                                    type="text"
                                    defaultValue={user.DS_NOME}
                                    name="name"
                                    label="Nome"
                                    registerOptions={{
                                        required: "Insira o nome do usuário",
                                    }}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="form-group col-12 col-lg-4">
                                <label>Email</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    disabled
                                    value={user.DS_EMAIL}
                                />
                            </div>
                            {!OrgInfor.FL_SSO && (
                                <div className="form-group col-12 col-lg-4">
                                    <label>Login</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        disabled
                                        value={user.DS_LOGIN}
                                    />
                                </div>
                            )}
                            <div className="form-group col-12 col-lg-4">
                                <UnForm.Input
                                    type="text"
                                    name="cpf"
                                    label="CPF"
                                    defaultValue={user.DS_CPF || ""}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="form-group col-12 col-lg-4">
                                <UnForm.Input
                                    type="text"
                                    name="rg"
                                    label="RG"
                                    defaultValue={user.NR_RG || ""}
                                    onChange={handleInputChange}
                                />
                            </div>
                            {OrgInfor.COD_ERP_INTEGRACAO === "UAU" && (
                                <>
                                    <div className="form-group col-12 col-lg-4">
                                        <UnForm.Input
                                            type="text"
                                            name="LoginUAU"
                                            label="Login UAU"
                                            defaultValue={
                                                user.DS_LOGIN_UAU || ""
                                            }
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className="form-group col-12 col-lg-4">
                                        <UnForm.Input
                                            type="password"
                                            name="SenhaUAU"
                                            label="Senha UAU"
                                            defaultValue={
                                                user.DS_SENHA_UAU || ""
                                            }
                                            onChange={handleInputChange}
                                            autoComplete="new-password"
                                        />
                                    </div> 
                                </>
                            )}
                            <div className="form-group col-12 col-lg-4">
                                <UnForm.Input
                                    type="number"
                                    name="NRad"
                                    label="NR Agente Discador"
                                    defaultValue={user.NR_AGENTE_DISCADOR || ""}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="form-group col-12 col-lg-4">
                                <UnForm.LazySelect
                                    controller={ListarUraTelefoneController}
                                    getDS={(r) => r.NR_RAMAL}
                                    getKeyValue={(r) => r.ID_RAMAL}
                                    name="IDr"
                                    label="ID RAMAL"
                                    defaultValue={user.ID_RAMAL_DISCADOR || ""}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="form-group col-12 col-lg-4">
                                <label>DDI</label>
                                <UnForm.Input
                                    id="COD_DDI"
                                    name="COD_DDI"
                                    registerOptions={{
                                        required:
                                            nrTelefone && nrTelefone.length > 0
                                                ? "Insira o DDI"
                                                : false,
                                    }}
                                    defaultValue={user.COD_DDI || ""}
                                    onChange={handleInputChange}
                                />
                            </div>

                            <div className="form-group col-12 col-lg-4">
                                <label>DDD</label>
                                <UnForm.Input
                                    id="COD_DDD"
                                    name="COD_DDD"
                                    registerOptions={{
                                        required:
                                            nrTelefone && nrTelefone.length > 0
                                                ? "Insira o DDD"
                                                : false,
                                    }}
                                    defaultValue={user.COD_DDD || ""}
                                    onChange={handleInputChange}
                                />
                            </div>

                            <div className="form-group col-12 col-lg-4">
                                <label>Telefone</label>
                                <UnForm.Input
                                    id="NR_TELEFONE_WPP"
                                    name="NR_TELEFONE_WPP"
                                    onChange={(e) => {
                                        handleInputChange();
                                        setNrTelefone(e.target.value);
                                    }}
                                    maxLength={9}
                                    defaultValue={user.NR_TELEFONE_WPP || ""}
                                />
                            </div>
                            <div className="form-group col-12 col-lg-4">
                                <UnForm.LazySelect
                                    className="form-control placeholder-dark-75"
                                    label="Copiar perfil de"
                                    name="ID_USUARIO"
                                    controller={ListarUsuariosController}
                                    getKeyValue={(u) => u.ID_USUARIO}
                                    getDS={(u) => u.DS_NOME}
                                    onChange={(e) => {
                                        handleInputChange();
                                        setIdUsuarioCopia(
                                            Number(e.target.value)
                                        );
                                    }}
                                >
                                    <option></option>
                                </UnForm.LazySelect>
                            </div>
                            <div className="form-group col-12 col-lg-4">
                                <UnForm.LazySelect
                                    className="form-control placeholder-dark-75"
                                    label="Módulo Principal"
                                    name="ID_MODULO_PRINCIPAL"
                                    controller={ListarModulosController}
                                    getKeyValue={(u) => u.ID_MODULO}
                                    getDS={(u) => u.DS_MODULO}
                                    defaultValue={
                                        user.ID_MODULO_PRINCIPAL || ""
                                    }
                                    onChange={handleInputChange}
                                >
                                    <option></option>
                                </UnForm.LazySelect>
                            </div>

                            <div className="form-group col-12 col-lg-4">
                                <label htmlFor="foto">Foto do Usuário</label>
                                <div className="custom-file">
                                    <input
                                        id="foto"
                                        name="foto"
                                        type="file"
                                        className="custom-file-input"
                                        onChange={(e) => {
                                            handleInputChange();
                                            if (e.target.files) {
                                                setFileFotoUsuario(
                                                    e.target.files?.[0]
                                                );
                                            }
                                        }}
                                    />
                                    <label
                                        className="custom-file-label"
                                        htmlFor="foto"
                                    >
                                        {fileFotoUsuario?.name ??
                                            "Foto do Usuário"}
                                    </label>
                                </div>
                            </div>

                            <div className="form-group col-12 col-lg-4">
                                <label htmlFor="assinatura">
                                    Assinatura do Usuário
                                </label>
                                <div className="custom-file">
                                    <input
                                        id="assinatura"
                                        name="assinatura"
                                        type="file"
                                        className="custom-file-input"
                                        onChange={(e) => {
                                            handleInputChange();
                                            if (e.target.files) {
                                                setFile(e.target.files?.[0]);
                                            }
                                        }}
                                    />
                                    <label
                                        className="custom-file-label"
                                        htmlFor="assinatura"
                                    >
                                        {file?.name ?? "Assinatura do Usuário"}
                                    </label>
                                </div>
                            </div>

                            <div className="form-group col-12 col-lg-4">
                                <label>Perfil de Acesso do Usuário</label>
                                <select
                                    className="form-control placeholder-dark-75"
                                    name="ID_PERFIL_USUARIO"
                                    defaultValue={user.ID_PERFIL_USUARIO || ""}
                                    onChange={(e) => {
                                        handleInputChange();
                                        setIdPerfilUsuario(
                                            Number(e.target.value)
                                        );
                                    }}
                                >
                                    <option></option>
                                    {lstPerfilUsuario?.map((perfil) => (
                                        <option
                                            key={perfil.ID_PERFIL_USUARIO}
                                            value={perfil.ID_PERFIL_USUARIO}
                                        >
                                            {perfil.DS_PERFIL_USUARIO}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            {showSubmit && (
                                <UnForm.SubmitButton
                                    outline
                                    id="dados_form_submit_button"
                                    color="success"
                                    iconSize="lg"
                                    className="d-none font-weight-bold col-12"
                                    icon={faEdit}
                                >
                                    Atualizar Dados
                                </UnForm.SubmitButton>
                            )}
                        </UnForm>
                    </FormProvider>
                </div>
            </div>{" "}
        </OrSpinner>
    );
}
